<template>
<div class="w-full py-6 md:py-8">
    <div class="wrapper flex-col flex items-center m-auto">
        <h1 class="px-4 md:p-0 w-full md:w-auto text-center">{{ pages('title') }}</h1>
        <p class="px-4 md:p-0 text-center" v-html="pages('text')"></p>
        <div class="flex flex-col items-center mt-6 px-4 md:p-0" v-if="Object.keys(errors).length > 0">
            <h3 class="mb-2">{{translations.validation_title}}</h3>
            <p v-if="genericError" class="text-red-500 italic">{{ translations.generic_validation_error }}</p>
            <p v-for="error in errors" class="text-red-500 italic">{{ error }}</p>
        </div>
        <div class="content w-full mt-8 md:mt-12 relative">
            <Loader v-if="loading" />
            <Login
                v-if="page == 'login'"
                @login="login"
                :translations="translations"
                :code="code"
                :isReturn="isReturn"
                :isTest="isTest"
                :testExternalId="testExternalId"
                :testEmail="testEmail"
            />
            <Register
                v-if="page == 'register'"
                :orders="selectedOrders"
                @continue="addForm"
                :globalReasons="globalReasons"
                @back="goBack('login')"
                :translations="translations"
                :isReturn="isReturn"
            />
            <Details
                v-if="page == 'details'"
                @back="goBack('register')"
                :customerDetails="customerDetails"
                :errors="errors"
                @submitErrand="submitErrand"
                :translations="translations"
                :isReturn="isReturn"
            />
            <Sent
                v-if="page == 'sent'"
                @back="goBack('login')"
                :translations="translations"
            />
            <ErrorPage
                v-if="page == 'error'"
                @back="goBack('login')"
                :translations="translations"
            />
        </div>
    </div>
</div>
</template>

<script>
import Bugsnag from '@bugsnag/js'
import Register from './Register'
import Login from './Login'
import Details from './Details'
import Sent from './Sent'
import ErrorPage from './ErrorPage'
export default {
    components: {
        Register,
        Login,
        Sent,
        Details,
        ErrorPage
    },
    props: {
        initialTranslations: {
            required: true
        },
        code: String,
        isReturn: Boolean,
        isTest: Boolean,
        testExternalId: String,
        testEmail: String
    },
    data() {
        return {
            form: {
                selectedArticles: null,
                reasonForAllChecked: false,
                globalReasons: [],
                reasonForAllText: '',
                customer: null,
                domain: this.code,
                country_id: null,
                errandTypeId: this.isReturn ? 1 : 2,
            },
            translations: this.initialTranslations,
            orderDetails: null,
            customerDetails: {},
            loading: false,
            errors: [],
            genericError: false,
            selectedOrders: [],
            page: 'login',
        }
    },
    methods: {
        pages(key) {
            let pages = {
                login: {
                    title: this.translations.login_title,
                    text: this.translations.login_message
                },
                register: {
                    title: this.translations.register_title,
                    text: this.translations.register_message
                },
                sent: {
                    title: this.translations.sent_title,
                    text: this.translations.sent_message
                },
                details: {
                    title: this.translations.details_title,
                    text: this.translations.details_message
                },
                error: {
                    title: this.translations.errorpage_title,
                    text: this.translations.errorpage_message
                }
            }
            return pages[this.page][key]
        },
        goBack(page) {
            this.errors = []
            this.genericError = false
            this.page = page
        },
        async submitErrand(customer) {
            if(this.isTest) {
                this.page = 'sent'
                return
            }
            this.genericError = false
            this.form.customer = customer
            this.errors = []
            this.loading = true
            const form = this.isReturn ? 'returnform' : 'claimform'
            try {
                const formData = this.toFormData(this.form)
                const { data, status } = await axios.post('/errand/' + form, formData)
                if(status == 200) {
                    this.page = 'sent'
                }
                else {
                    this.page = 'error'
                }
            } catch (error) {
                Bugsnag.notify(error)
                //422 for validation messages
                if(error.response && error.response.status == 422) {
                    this.setErrors(error.response.data.errors)
                }
                else {
                    this.page = 'error'
                }
            }
            this.loading = false
        },
        //Since we're sending images for claim errands
        //We have to use formData.. This function recreates the same object structure as this.form but as formData
        toFormData(obj, form, namespace) {
            let fd = form || new FormData();
            let formKey;

            for(let property in obj) {
                if (namespace) {
                    formKey = namespace + '[' + property + ']';
                } else {
                    formKey = property;
                }

                // if the property is an object, but not a File, use recursivity.
                if (obj[property] instanceof Date) {
                    fd.append(formKey, obj[property].toISOString());
                }
                else if (typeof obj[property] === 'object' && !(obj[property] instanceof File)) {
                    this.toFormData(obj[property], fd, formKey);
                } else {
                    let value = obj[property]
                    //We do not want to cast true false as strings so we convert it to 1 or 0 instead
                    if(value == true || value == false) {
                        value = value ? 1 : 0
                    }
                    // if it's a string or a File object
                    fd.append(formKey, value);
                }
            }
            return fd;
        },

        setErrors(errors) {
            let filteredErrors = []
            for (const error in errors) {
                if (Object.hasOwnProperty.call(errors, error)) {
                    if(errors[error][0].indexOf("validation") == -1 && filteredErrors.indexOf(errors[error][0]) == -1) {
                        filteredErrors.push(errors[error][0])
                    } else {
                        this.genericError = true
                    }
                }
            }
            this.errors = filteredErrors
        },
        addForm(form) {
            this.form.selectedArticles = form.selectedArticles
            this.form.reasonForAllText = form.reasonForAllText
            this.form.reasonForAllChecked = form.reasonForAllChecked
            this.form.globalReasons = form.addedGlobalReasons
            this.page = 'details'
        },
        login(data) {
            this.selectedOrders = data.orders
            this.customerDetails = data.customerInfo
            this.translations = data.translations
            this.form.domain = data.domain
            this.form.country_id = data.country_id
            this.globalReasons = data.globalReasons
            this.page = 'register'
        },
        register() {
            this.page = 'articles'
        }
    },
};
</script>


<style lang="scss" scoped>
p {
    line-height: 1.3rem;
}


</style>
